import type { ColorSystemOptions } from '@mui/material/styles';
import { type DesignTokens, darkTokens, lightTokens } from './tokens';

function toPalette(t: DesignTokens, mode: 'light' | 'dark'): ColorSystemOptions['palette'] {
  return {
    primary: {
      main: t.primary,
      light: t.primaryBright,
      dark: t.primaryStrong,
      // The bright dark-mode primary needs dark ink on top of it.
      contrastText: mode === 'dark' ? '#1B2410' : '#FFFFFF',
    },
    secondary: { main: '#3B82F6', contrastText: '#FFFFFF' },
    success: { main: t.ok, contrastText: '#FFFFFF' },
    error: { main: t.bad, contrastText: '#FFFFFF' },
    warning: { main: t.warn, contrastText: '#1B1300' },
    info: { main: '#3B82F6', contrastText: '#FFFFFF' },
    background: { default: t.bg, paper: t.panel },
    text: { primary: t.text, secondary: t.muted, disabled: t.faint },
    divider: t.border,
    // The full prototype token set, reachable as `md.*` in sx and `theme.vars.palette.md.*`.
    md: t,
  };
}

export const lightPalette = toPalette(lightTokens, 'light');
export const darkPalette = toPalette(darkTokens, 'dark');
